module.exports = __webpack_public_path__ + "img/mindful_days_180.1649fd35.svg";